import { Box } from "@mui/material";
import { useTranslation } from "react-i18next";
import dayjs, { Dayjs } from "dayjs";
import CustomDatePicker from "../customDatePicker/customDatePicker.component";

export interface DateRangeValue {
  start_date: string | null;
  end_date: string | null;
}

interface DateRangeFilterProps {
  value: DateRangeValue;
  onChange: (value: DateRangeValue) => void;
}

export default function DateRangeFilter({ value, onChange }: DateRangeFilterProps) {
  const { t } = useTranslation();

  return (
    <Box sx={{ display: "flex", flexWrap: "wrap", gap: 2, alignItems: "center" }}>
      <CustomDatePicker
        label={t("From")}
        value={value.start_date ? dayjs(value.start_date) : null}
        onChange={(newValue: Dayjs | null) =>
          onChange({ ...value, start_date: newValue ? newValue.format("YYYY-MM-DD") : null })
        }
        slotProps={{ textField: { size: "small" } }}
      />
      <CustomDatePicker
        label={t("To")}
        value={value.end_date ? dayjs(value.end_date) : null}
        onChange={(newValue: Dayjs | null) =>
          onChange({ ...value, end_date: newValue ? newValue.format("YYYY-MM-DD") : null })
        }
        slotProps={{ textField: { size: "small" } }}
      />
    </Box>
  );
}
